export const visit = (vm, at) => {
at({ "pt-br": { "priceComponents": { "pricePerMonth": "{{price}}/m\xEAs", "pricePerMonthPerSeat": "{{price}}/m\xEAs/licen\xE7a", "subtexts": { "startsAt": "A partir de" } } } });
};